import { Component, Input, inject } from "@angular/core";

import { CallToActionComponent } from "@hermes/aphrodite/call-to-action";
import { SvgIconComponent, registerSvgs, svgVto } from "@hermes/aphrodite/svg";
import { VtoType } from "@hermes/api-model-product";

import {
    VtoModalService,
    VtoModalServiceModule,
} from "@hermes/fragments/vto-button";
import { EDITO_PAGE, VtoFacade } from "@hermes/states/vto";
import { ImageUrlPipeModule } from "@hermes/utils-generic/pipes/image-url";

@Component({
    selector: "h-cta-vto-button",
    templateUrl: "./cta-vto-button.component.html",
    styleUrls: ["./cta-vto-button.component.scss"],
    imports: [
        CallToActionComponent,
        VtoModalServiceModule,
        SvgIconComponent,
        ImageUrlPipeModule,
    ],
})
export class CtaVtoButtonComponent {
    private vtoModalService = inject(VtoModalService);
    private vtoFacade = inject(VtoFacade);

    @Input()
    public text!: string;

    @Input()
    public vtoType!: VtoType;

    constructor() {
        registerSvgs([svgVto]);
    }

    public click(): void {
        this.vtoFacade.updateCurrentVtoType(this.vtoType);
        this.vtoModalService.openVtoModal(EDITO_PAGE, this.text);
    }
}
